<div class="grid-wrap">
  <div class="full-view-image-grid" #imageGrid *ngIf="flags?.length > 0">
    <ng-container *ngFor="let flag of flags; let i = index">
      <div class="image-card" [attr.data-flag-id]="flag.id">
        <div class="image-container" (mouseleave)="flag.showInfo = false">
          <div class="cta-button cta-drag-handle" (click)="$event.stopPropagation()">
            <img class="drag-handle" src="assets/img/svg/drag-handle-white.svg" alt="Drag" />
          </div>
          <img
            (click)="openPicture(flag); $event.stopPropagation()"
            [src]="flag.imageUrl || embeddedUrl(flag.picture) + '?t=' + Date.now()"
            *ngIf="flag.picture"
            alt="" />
          <svg
            *ngIf="!flag.picture"
            xmlns="http://www.w3.org/2000/svg"
            width="118"
            height="118"
            viewBox="0 0 119 118"
            fill="none">
            <path
              d="M34.9086 14.7043C24.0477 14.7043 15.2419 23.5101 15.2419 34.371V78.621V83.5377C15.2419 94.3986 24.0477 103.204 34.9086 103.204H84.0752C94.9361 103.204 103.742 94.3986 103.742 83.5377V78.621V34.371C103.742 23.5101 94.9361 14.7043 84.0752 14.7043H34.9086ZM34.9086 24.5377H84.0752C89.5081 24.5377 93.9085 28.9381 93.9085 34.371L93.9282 64.8346C90.103 61.2848 86.2042 59.0625 81.9218 58.9543C81.7693 58.9494 81.7742 58.9543 81.6169 58.9543C76.0266 58.9543 69.812 63.2515 65.6377 68.6352C64.5708 66.2261 63.4941 63.8465 62.2551 61.5651C56.4535 50.8517 50.1158 44.2191 42.2836 44.2043C35.6264 44.1896 29.9133 49.6323 25.036 57.086L25.0753 34.371C25.0753 28.9381 29.4757 24.5377 34.9086 24.5377ZM79.1585 34.371C76.4445 34.371 74.2419 36.5737 74.2419 39.2877C74.2419 42.0017 76.4445 44.2043 79.1585 44.2043C81.8725 44.2043 84.0752 42.0017 84.0752 39.2877C84.0752 36.5737 81.8725 34.371 79.1585 34.371ZM42.2836 54.0377C45.1451 54.0426 49.4915 58.4971 53.651 66.1769C55.303 69.2154 56.7828 72.5636 58.1103 75.8578C58.9068 77.8245 59.5214 79.3291 59.7968 80.1551C61.139 84.172 66.5866 84.7423 68.7106 81.0793C68.922 80.7155 69.3055 80.0173 69.9398 79.0831C71.0018 77.5098 72.2113 75.9169 73.4748 74.4714C76.6313 70.8527 79.6748 68.7877 81.6169 68.7877C83.5786 68.8368 86.6073 70.897 89.7589 74.4714C91.0372 75.9218 92.2172 77.5098 93.2939 79.0831C93.6332 79.5748 93.6824 79.806 93.9085 80.1551V83.5377C93.9085 88.9706 89.5081 93.371 84.0752 93.371H34.9086C29.4757 93.371 25.0753 88.9706 25.0753 83.5377V79.388C25.385 78.5129 25.798 77.4754 26.4569 75.8578C27.7991 72.5636 29.2544 69.2203 30.9162 66.1769C35.1101 58.4823 39.427 54.0328 42.2836 54.0377Z"
              fill="#6D7275" />
          </svg>
          <!-- Subtype -->
          <div
            class="pill"
            [ngClass]="{
              violation: flag.subtype?.type?.name === 'Violation',
              discrepancy: flag.subtype?.type?.name === 'Discrepancy'
            }"
            *ngIf="!flag?.groupId">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M5.99837 1.84277C4.96904 1.84277 4.13504 2.14564 3.49837 2.65531C3.19704 2.89644 2.8537 3.29244 2.7277 3.55111C2.68237 3.64411 2.66504 3.73924 2.66504 3.84277C2.66504 4.75944 2.66504 10.2594 2.66504 11.1761V14.5094C2.66504 14.8776 2.96371 15.1761 3.33171 15.1761C3.69971 15.1761 3.99837 14.8776 3.99837 14.5094L3.99703 11.3757C4.05503 11.283 4.13637 11.1866 4.33171 11.0302C4.73637 10.7066 5.27771 10.5094 5.99837 10.5094C6.36437 10.5094 6.57037 10.559 6.91504 10.6969C6.95104 10.7114 7.11971 10.7829 7.16504 10.8011C7.82171 11.0637 8.39637 11.1761 9.33171 11.1761C11.6997 11.1761 13.3317 9.54431 13.3317 7.17611C13.3317 5.91104 13.3317 4.58838 13.3317 3.84277C13.3317 2.80791 12.3664 1.84277 11.3317 1.84277C11.091 1.84277 10.8657 1.89571 10.6024 1.98864C10.461 2.03857 9.90304 2.25597 9.99837 2.21777C9.50771 2.41391 9.13771 2.50944 8.66504 2.50944C8.21171 2.50944 7.94837 2.44057 7.49837 2.23864C7.40437 2.19631 7.33503 2.17511 7.29036 2.15531C6.8177 1.94597 6.47371 1.84277 5.99837 1.84277Z"
                [attr.fill]="flag.subtype.type.name === 'Violation' ? '#DC3E3E' : '#EC9006'" />
            </svg>
            <div class="violation-label">{{ flag.subtype?.type?.name }}</div>
          </div>

          <!-- Deadline pill -->
          <div class="pill violation" *ngIf="shouldShowFlagViolationDeadline(flag)">
            <img src="assets/img/svg/deadline-calendar.svg" style="border-radius: 0" alt="Deadline" />
            <div class="violation-label">{{ flag.violation.deadline | date: 'MM/dd/yyyy' }}</div>
          </div>

          <!-- Checkbox -->
          <div
            class="cta-checkbox"
            [ngClass]="{
              'show-checkbox': anyCheckboxChecked,
              'hover-checkbox': !anyCheckboxChecked
            }">
            <input
              type="checkbox"
              class="flag-checkbox"
              [formControl]="flag.checkbox"
              (click)="$event.stopPropagation()" />
          </div>

          <!-- Show Info -->
          <div class="cta-bottom-left cta-button" (click)="flag.showInfo = !flag.showInfo" *ngIf="!flag?.groupId">
            <img src="assets/img/svg/info.svg" class="info-icon" alt="" />
            <span>Show info</span>
          </div>

          <!-- Info box -->
          <div class="info-box" *ngIf="flag.showInfo">
            <div class="info-pill-row">
              <div class="info-pill green" *ngIf="getViolationValue(flag?.subtype?.name)">
                <img src="assets/img/svg/key.svg" />
                <span>{{ getViolationValue(flag?.subtype?.name) }}</span>
              </div>
              <div class="info-pill blue" style="height: fit-content">
                <img src="assets/img/svg/exclamation.svg" />
                <span>{{ flag.score }}</span>
              </div>
            </div>
            <div class="info-pill blue">
              <img src="assets/img/svg/tools.svg" />
              <span>{{ flag.label }}</span>
            </div>
            <div class="info-pill yellow">
              <img src="assets/img/svg/yellow-calendar.svg" />
              <span>{{ flag.date | date: 'MM/dd/yyyy' }}</span>
            </div>
          </div>

          <div
            class="cta-bottom-li-left cta-button"
            [style.right]="showResolveOptions ? '92px' : flag?.groupId ? '52px' : '12px'"
            (click)="openFlagChangelog(flag); $event.stopPropagation()">
            <img style="border-radius: 0" src="assets/img/svg/changelog.svg" />
            <div class="tooltip">Changelog</div>
          </div>

          <div
            class="cta-bottom-li-left cta-button"
            *ngIf="flag?.groupId && showResolveOptions"
            (click)="onResolveFlag(flag); $event.stopPropagation()">
            <img src="assets/img/svg/resolve.svg" />
            <div class="tooltip">Resolve</div>
          </div>

          <div
            class="cta-bottom-right cta-button"
            *ngIf="flag?.groupId && showResolveOptions && resolveBarSelectedTab !== 'partial'"
            (click)="onPartialResolveFlag(flag); $event.stopPropagation()">
            <img src="assets/img/svg/partial-resolve.svg" />
            <div class="tooltip">Partial resolve</div>
          </div>

          <div
            class="cta-bottom-right cta-button"
            *ngIf="
              flag?.groupId &&
              ((showResolveOptions && resolveBarSelectedTab === 'partial') || selectedTab === 'resolved')
            "
            (click)="onUnresolveFlag(flag); $event.stopPropagation()">
            <img src="assets/img/svg/unresolve.svg" />
            <div class="tooltip">Unresolve flag</div>
          </div>

          <!-- Close/Include Toggle -->
          <div
            class="cta-bottom-right cta-button"
            *ngIf="flag?.groupId && !showResolveOptions && !(selectedTab === 'resolved')"
            (click)="onIgnoreFlag(flag)">
            <img
              [src]="selectedTab === 'included' ? 'assets/img/x.svg' : 'assets/img/svg/check.svg'"
              class="close"
              alt="" />
            <div class="tooltip">{{ selectedTab === 'included' ? 'Exclude flag' : 'Include flag' }}</div>
          </div>
        </div>
        <div class="image-desc">
          {{ flag?.label }} / {{ flag?.question }}
          <div class="question-icon" (click)="onQuestion(flag); $event.stopPropagation()">
            <img src="assets/img/svg/question.svg" alt="" />
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="no-data" *ngIf="flags?.length === 0">
    <span>This group doesn't have any flags yet.</span>
  </div>
</div>

<div
  *ngIf="selectedPicture"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    z-index: 1020;
    display: flex;
  ">
  <div style="flex: 1">
    <app-picture-viewer
      [picture]="selectedPicture"
      [flags]="[selectedFlag]"
      (moveFlag)="moveFlag($event)"
      [hideVersionSelect]="true"
      (markupChanged)="updateThumb($event)">
    </app-picture-viewer>

    <i
      (click)="selectedPicture = false"
      class="fa fa-arrow-left"
      style="
        text-shadow: 0px 0px 3px #000;
        color: #fff;
        cursor: pointer;
        position: absolute;
        top: 15px;
        left: 65px;
        font-size: 25px;
        z-index: 400;
      "></i>
  </div>
</div>

<app-flag-manager-issue-detail
  #issueDetailModal
  [currentFlags]="flags"
  [selectedFlag]="selectedFlag"></app-flag-manager-issue-detail>
